export const companyId =
  localStorage.getItem("companyId") ?? "66f630d975c681aeff9d95fd";
export const companyId1 = "66f630d975c681aeff9d95fd";
export const userId = "66f500a7914c7edbf8a22bd8";
export const roleID = localStorage.getItem("roleId");
export const governanceId = "673ef8882acd6f87ee3b7de1";
export const token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NzIyMjQ5MTUwODZkMWMwYzM4NGM3ZjYiLCJjb21wYW55SWQiOiI2NmYxNTFhMDRlNzI0MjcwZGNkZjU5YjQiLCJpYXQiOjE3MzMxMTg1MDksImV4cCI6MTc0MDg5NDUwOX0.W3Elizrv42AKXCR_b-iZiRWOG_zb5c73toizRMcrCa8";

export const reviewBRSR=JSON.parse(localStorage.getItem("brsrReview")) ;
export const reviewGRI=JSON.parse(localStorage.getItem("griReview")) ;
export const griReview = JSON.parse(localStorage.getItem("griReview")) ;
export const brsrReview=JSON.parse(localStorage.getItem("brsrReview")) ;
// export const getGriReview   = () => JSON.parse(localStorage.getItem('griReview'));
// export const getBrsrReview  = () => JSON.parse(localStorage.getItem('brsrReview'));
